import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "support-card__content" }
const _hoisted_2 = { class: "support-card__heading" }
const _hoisted_3 = { class: "support-card__item-list" }
const _hoisted_4 = { class: "support-card__item-list-items" }
const _hoisted_5 = {
  key: 0,
  class: "support-card__quick-links"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "support-card__quick-links-heading" }, " Quick links ", -1 /* HOISTED */)
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: {
			name: 'my-boundary__page',
			params: {
				page: $props.page.slug
			}
		},
    class: "support-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["support-card__icon", 'support-card__icon--' + $props.page.icon.replace( /_/g, '-' )])
      }, null, 2 /* CLASS */),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["support-card__summary", { 'support-card__summary--half-width': $props.page.quick_links.length }])
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString($props.page.title), 1 /* TEXT */),
            _createElementVNode("ul", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.item_list, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: 'support-card-' + index,
                    class: "support-card__item-list-item"
                  }, [
                    _createVNode(_component_router_link, {
                      to: {
										name: 'my-boundary__page',
										params: {
											page: $props.page.slug
										},
										hash: `#${ $options.slugifyTitle( item ) }`
									},
                      class: "support-card__item-link"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ], 2 /* CLASS */),
        ($props.page.quick_links.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.page.quick_links, (quick_link) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: quick_link }, [
                  (quick_link.logo_monochrome.length || quick_link.logo_colour.length)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: quick_link.external_url,
                        target: "_blank",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        (quick_link.logo_monochrome.length)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: quick_link.logo_monochrome[0].url,
                              class: "support-card__quick-link"
                            }, null, 8 /* PROPS */, _hoisted_8))
                          : (quick_link.logo_colour.length)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: quick_link.logo_colour[0].url,
                                class: "support-card__quick-link"
                              }, null, 8 /* PROPS */, _hoisted_9))
                            : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_7))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["to"]))
}